// extracted by mini-css-extract-plugin
export default {"logoLink":"LogoLink_logoLink__Nxb6b"};